import { privacy } from './__modules/privacy';
import { slider } from './__modules/slider';
import { newsletter } from './__modules/newsletter';

$(document).ready(() => {
	slider();
	privacy();
	newsletter();
});
